import type { JSX } from "solid-js";
import { cn } from "@mealplan/shared";

interface PageContainerProps {
  children: JSX.Element;
  class?: string;
  containerClass?: string;
  /**
   * Strictly typed max-width class.
   * If a new size is needed (e.g. "md", "xl"), add it to this union type
   * and include its corresponding CSS class in the switch statement below.
   */
  maxWidth?: "lg" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl" | "full";
}

export function PageContainer(props: PageContainerProps) {
  const maxWidthClass = () => {
    switch (props.maxWidth) {
      case "lg": {
        return "max-w-lg";
      }
      case "2xl": {
        return "max-w-2xl";
      }
      case "3xl": {
        return "max-w-3xl";
      }
      case "4xl": {
        return "max-w-4xl";
      }
      case "5xl": {
        return "max-w-5xl";
      }
      case "6xl": {
        return "max-w-6xl";
      }
      case "7xl": {
        return "max-w-7xl";
      }
      case "full": {
        return "max-w-full";
      }
      case undefined: {
        return "max-w-6xl";
      }
    }
    return "max-w-6xl";
  };

  return (
    <div class={cn("flex-1 overflow-y-auto p-6 md:p-10 select-none", props.containerClass)}>
      <div class={cn("mx-auto w-full", maxWidthClass(), props.class)}>{props.children}</div>
    </div>
  );
}
